import React, { useState } from 'react';
import { Mail, X, Sparkles, Copy, Check } from 'lucide-react';

function CopyField({ label, field, text, copied, onCopy, children }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <p className="text-[10px] uppercase tracking-wider text-amber-700/60 font-sans font-semibold">{label}</p>
        <button onClick={() => onCopy(text, field)} className="text-[10px] text-amber-600 font-sans flex items-center gap-1 hover:text-amber-800" data-testid={`copy-${field}`}>
          {copied === field ? <><Check size={10} /> Copied</> : <><Copy size={10} /> Copy</>}
        </button>
      </div>
      {children}
    </div>
  );
}

export default function AIReplyPanel({ reply, email, onClose }) {
  const [copied, setCopied] = useState('');

  const copy = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(field);
      setTimeout(() => setCopied(''), 2000);
    } catch { /* clipboard not available */ }
  };

  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-lg p-4 mb-5 space-y-3" data-testid="ai-reply-panel">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Sparkles size={14} className="text-amber-600" />
          <p className="text-xs font-sans font-semibold text-amber-800">AI Suggested Reply</p>
        </div>
        <button onClick={onClose} className="text-amber-400 hover:text-amber-600" data-testid="ai-reply-close"><X size={14} /></button>
      </div>
      <CopyField label="Subject" field="subject" text={reply.subject} copied={copied} onCopy={copy}>
        <p className="text-sm font-sans font-medium text-earth-dark bg-white rounded px-3 py-2 border border-amber-200" data-testid="ai-reply-subject">{reply.subject}</p>
      </CopyField>
      <CopyField label="Email Body" field="body" text={reply.body} copied={copied} onCopy={copy}>
        <div className="text-sm font-sans text-earth/80 bg-white rounded px-3 py-2 border border-amber-200 whitespace-pre-wrap max-h-[200px] overflow-y-auto" data-testid="ai-reply-body">{reply.body}</div>
      </CopyField>
      <a
        href={`mailto:${email}?subject=${encodeURIComponent(reply.subject)}&body=${encodeURIComponent(reply.body)}`}
        className="w-full inline-flex items-center justify-center gap-1.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-sans font-semibold text-xs px-4 py-2.5 rounded-md hover:from-amber-600 hover:to-orange-600 transition-all shadow-sm"
        data-testid="send-ai-reply"
      >
        <Mail size={12} /> Open in Email Client with AI Reply
      </a>
    </div>
  );
}
